import { deleteRequest, getRequest, postRequest, putRequest } from 'config/Axios/baseConfig';
import {
  LvTimePayload,
  LvTimeResponse,
  LvTimeSingleResponse
} from 'Interfaces/ReferenceInterfaces/LvTimeInterface';

export const lvTimeServices = {
  getAllLvTimes: (page = 1, pageSize = 10000): Promise<LvTimeResponse> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await getRequest<LvTimeResponse>(
          `pps/lv-times?page=${page}&page_size=${pageSize}`
        );
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  getLvTimeById: (id: number): Promise<LvTimeSingleResponse> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await getRequest<LvTimeSingleResponse>(`pps/lv-times/${id}/`);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  createLvTime: (lvTimeData: LvTimePayload): Promise<LvTimeSingleResponse> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await postRequest<LvTimeSingleResponse>('pps/lv-times/', lvTimeData);
        resolve(data);
      } catch (error: any) {
        // If the error has a response with data, resolve with that data
        if (error.response?.data) {
          resolve(error.response.data);
        } else {
          reject(error);
        }
      }
    });
  },

  updateLvTime: (id: number, lvTimeData: LvTimePayload): Promise<LvTimeSingleResponse> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await putRequest<LvTimeSingleResponse>(`pps/lv-times/${id}/`, lvTimeData);
        resolve(data);
      } catch (error: any) {
        // If the error has a response with data, resolve with that data
        if (error.response?.data) {
          resolve(error.response.data);
        } else {
          reject(error);
        }
      }
    });
  },

  deleteLvTime: (id: number): Promise<any> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await deleteRequest(`pps/lv-times/${id}/`);
        resolve(data);
      } catch (error: any) {
        // If the error has a response with data, resolve with that data
        if (error.response?.data) {
          resolve(error.response.data);
        } else {
          reject(error);
        }
      }
    });
  }
};
